import React, { useEffect, useState } from 'react'
import useTranslation from 'next-translate/useTranslation'
import usePrompts from 'tennders-transactions/hooks/usePrompts'
import useTruckPlates from 'tennders-market/truck/hooks/useTruckPlates'
import useGenerateDoc from 'tennders-documents/hooks/useGenerateDoc'
import { apiGet } from 'tennders-stracture/libs/api'
import useTransactionDetailStore from 'tennders-transactions/stores/useTransactionDetailStore'
import { get } from 'lodash'
import GConfirm from '../popup/GConfirm'

const PromptMessage = (props) => {
  const {
    prompt,
    isVisible,
    customUpload
  } = props
  const { setPrompts } = usePrompts()
  const [cta, setcta] = useState(false)
  const [show, setshow] = useState(false)
  const [setAssignTruckLoadType] = useTransactionDetailStore(state => [state.setAssignTruckLoadType])
  const { updatePlateNumbers } = useTruckPlates()
  const { generateOrderDoc } = useGenerateDoc()
  const { t } = useTranslation()

  const read = async (force = false) => {
    setshow(false)
    setPrompts(false)
    if (get(prompt, 'id')) {
      apiGet(`prompt/${prompt.id}/read?force=${force}`, read)
    }
  }

  const close = () => {
    setshow(false)
    setPrompts(false)
    read(0)
  }

  const onSubmit = () => {
    setshow(false)
    read()
    switch (prompt.actionStr) {
      case 'FIND_LOADS':
        setAssignTruckLoadType('load-match')
        break
      case 'FIND_TRUCKS':
        setAssignTruckLoadType('truck-match')
        break
      case 'ASSIGN_LOADS':
        setAssignTruckLoadType('load')
        break
      case 'ASSIGN_TRUCKS':
        setAssignTruckLoadType('truck')
        break
      case 'UPDATE_TRUCK_PLATE':
        updatePlateNumbers(prompt.transaction)
        break
      case 'GENERATE_ORDER_DOCUMENT':
        generateOrderDoc(prompt.transaction)
        break
      case 'UPLOAD_ORDER_DOCUMENT':
        // refreshTransaction(prompt.transaction.id)
        break
      default:
        break
    }
  }

  useEffect(() => {
    if (isVisible && prompt) {
      setcta(prompt.cta)
      setshow(true)
    }
  }, [isVisible, prompt])

  return (
    <GConfirm
      withInputFile={prompt && prompt.actionStr === 'UPLOAD_ORDER_DOCUMENT'}
      docType="order_confirm"
      transaction={prompt && prompt.transaction}
      onOk={onSubmit}
      okTitle={cta || t('prompt:ok')}
      cancelTitle={t('prompt:willDoLater')}
      isOpen={show}
      extraTitle={t('prompt:alreadyCompleted')}
      extraAction={() => read(1)}
      title={t('prompt:nextStep')}
      // msg={message}
      onCancel={close}
      close={close}
      customUpload={customUpload}
    />
  )
}

export default PromptMessage
